import { ArrowLeft, Check, Eye } from 'lucide-react';
import type { DeviceMode } from '../HtmlEditor.types';

type TopToolbarProps = {
  name: string;
  savedAt: string;
  device: DeviceMode;
  canUndo: boolean;
  canRedo: boolean;
  disabled?: boolean;
  onNameChange: (name: string) => void;
  onClose?: () => void;
  onUndo: () => void;
  onRedo: () => void;
  onDeviceChange: (device: DeviceMode) => void;
  onPreview?: () => void;
  onSave?: () => void;
};

export function TopToolbar({
  name,
  savedAt,
  device,
  canUndo,
  canRedo,
  disabled,
  onNameChange,
  onClose,
  onUndo,
  onRedo,
  onDeviceChange,
  onPreview,
  onSave,
}: TopToolbarProps) {
  return (
    <header className='ee-topbar'>
      <div className='ee-topbar__left'>
        <button type='button' className='ee-iconbtn' onClick={onClose} title='Back' disabled={disabled}>
          <ArrowLeft size={16} />
        </button>
        <div className='ee-tplname'>
          <input
            className='ee-tplname__input'
            value={name}
            disabled={disabled}
            onChange={(e) => onNameChange(e.target.value)}
          />
          <span className='ee-tplname__meta'>Email · IT · Marketing</span>
        </div>
      </div>

      <div className='ee-topbar__center'>
        <button type='button' className='ee-iconbtn' disabled={disabled || !canUndo} onClick={onUndo} title='Undo'>
          ↶
        </button>
        <button type='button' className='ee-iconbtn' disabled={disabled || !canRedo} onClick={onRedo} title='Redo'>
          ↷
        </button>
        <span className='ee-savedot'>●</span>
        <span className='ee-savedat'>Last saved at {savedAt}</span>

        <div className='ee-device'>
          <button
            type='button'
            className={device === 'desktop' ? 'is-on' : ''}
            onClick={() => onDeviceChange('desktop')}
            title='Desktop'
            disabled={disabled}
          >
            🖥
          </button>
          <button
            type='button'
            className={device === 'mobile' ? 'is-on' : ''}
            onClick={() => onDeviceChange('mobile')}
            title='Mobile'
            disabled={disabled}
          >
            📱
          </button>
        </div>
      </div>

      <div className='ee-topbar__right ee-topbar-actions'>
        <button type='button' className='ee-btn' disabled={disabled} onClick={onPreview}>
          <Eye size={13} /> Preview & test
        </button>
        <button type='button' className='ee-btn ee-btn--primary' disabled={disabled} onClick={onSave}>
          <Check size={13} /> Save & exit
        </button>
      </div>
    </header>
  );
}
